import { render, staticRenderFns } from "./stages_dropdown.vue?vue&type=template&id=1274ec3d&"
import script from "./stages_dropdown.vue?vue&type=script&lang=js&"
export * from "./stages_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "stages_dropdown.vue"
export default component.exports